import { render, staticRenderFns } from "./LeadTable.vue?vue&type=template&id=20d918c4"
import script from "./LeadTable.vue?vue&type=script&lang=js"
export * from "./LeadTable.vue?vue&type=script&lang=js"
import style0 from "./LeadTable.vue?vue&type=style&index=0&id=20d918c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports